<span class="span-footer" *ngIf="urlData !== 'create-tickets'">Powered by {{client}} {{systemVersion}}</span>
